import { useEffect } from "react";
import ShortcutUtils from "../lib";
export default (key, callback) => {
    useEffect(() => {
        const handler = (e) => {
            if (e.code === ShortcutUtils.getKeyCode(key) &&
                !(e.target instanceof HTMLInputElement) &&
                !(e.target instanceof HTMLTextAreaElement))
                callback(e);
        };
        document.addEventListener("keyup", handler);
        return () => {
            document.removeEventListener("keyup", handler);
        };
    }, [callback]);
};
//# sourceMappingURL=useShortcut.js.map